export function LoadOrdersData(searchString, userID) {
  //-----LOAD ORDERS FOR THE GRID -----//

  let ordersArray = [];
  let numOrders = 0;

  const SearchString = searchString;

  const newDataSource = (SearchString) => {
    let string = SearchString;
    if (string === "") {
      string = "EMPTY_SEARCH_STRING";
    }
    const url = `/returnOrdersList/${string}/${userID}`;
    return fetch(url)
      .then((response) => response.json())
      .then((data) => {
        numOrders = data.length;
        return { data, count: data.length };
      });
  };
  ordersArray = newDataSource(SearchString);

  //----------//

  let returnValues = {
    data: ordersArray,
    count: numOrders,
  };

  return returnValues;
}
